import React, {
  useEffect,
  useRef,
  useImperativeHandle,
  forwardRef,
} from 'react';
import { useSelector } from 'react-redux';
import {  compressImage, useSetState } from 'utils/functions.utils';
import { Functions, Models, PrimaryButton } from 'utils/imports.utils';
import './file_upload.ui.scss';

interface IFileUpload {
  className?: string;
  onChange: any;
  children: any;
  type?: string;
  multiple?: boolean;
  folder?: string;
}

const FileUpload = forwardRef((props: IFileUpload, ref: any) => {
  //reference
  const inputFileRef: any = useRef();

  // State
  const [state, setState] = useSetState({
    compress_image:''
  });

  //Hooks
  useEffect(() => {
    const dropArea: any = document.getElementById('drag_area');
    const inputContainer = document.getElementById(
      'file_upload_box_label_content',
    );
    dropArea?.addEventListener('dragover', (e) => {
      e.preventDefault();
      // dropArea?.classList.add('upload_box_container_hover');
    });
    dropArea?.addEventListener('dragleave', () => {
      // dropArea?.classList.remove('upload_box_container_hover');
    });
    dropArea?.addEventListener('drop', (e) => {
      e.preventDefault();
      // dropArea?.classList.remove('upload_box_container_hover');
      uploadFiles(e.dataTransfer.files[0]);
    });
  }, []);

  useImperativeHandle(ref, () => ({
    openUpload() {
      inputFileRef?.current?.click();
    },
  }));

   // image compressor

  //Network req
  const uploadFiles = async (file: any) => {
    try {
      let body: any = {
        file_type: file.type,
        file_name: file.name,
      };
      if (props.folder) {
        body.folder = props.folder;
      }
      const content: any = await Models.auth.uploadFile(body);
      Functions.uploadFile(
        file,
        content.signedRequest,
        content.url,
        function (res) {
          setState({ profile_picture: res?.url });
          props.onChange(res?.url);
        },
      );
    } catch (error) {
      // toastifyError(error);
    }
  };

  const options = {
    maxSizeMB:1,
    maxWidthOrHeight: 1920,
    useWebWorker: true
  }
  //Logic
  const onChange = async (e: any) => {
     
    Functions.notiflixLoader('Uploading...');
    try {
      if (props.type == 'csv') {
        props.onChange(e.target.files[0]);
        Functions.notiflixRemove();
      } else {
        if (props.multiple) {
          for (let i = 0; i < e.target.files.length; i++) {
            let files = e.target.files;
            let getType = files[i].name.split('.').pop();
            if (
              files[i].type.split('/')[0] == 'video' ||
              files[i].type.split('/')[0] == 'audio'
            ) {
              Functions.notiflixFailure(`${getType} not supported`);
            } else {
              let time = new Date().getTime();
              let fileName = `${time}.${getType}`;
              let blob = files[i].slice(0, files[i].size, `image/${getType}`);
              let newFile = new File([blob], fileName, {
                type: `image/${getType}`,
              });
              let result: any = await compressImage(newFile);
              await uploadFiles(result);
              Functions.notiflixRemove();
            }
          }
        } else {
          let result:any = await compressImage(e.target.files[0])
          await uploadFiles(result);
          Functions.notiflixRemove();
        }
      }
    } catch (error) {
      Functions.notiflixFailure(error);
      console.log('error', error);
    } finally {
      Functions.notiflixRemove();
    }
  };

  return (
    <div id="drag_area">
      {props.children}
      <div className={'file_upload_wrapper'} id="file_upload_wrapper">
        <label
          className="file_upload_box_label_content"
          id="file_upload_box_label_content">
          <input
            type={'file'}
            ref={inputFileRef}
            onClick={(e: any) => (e.target.value = null)}
            className={'file_upload_box'}
            onChange={(e: any) => {
              onChange(e);
            }}
            multiple
          />
        </label>
      </div>
    </div>
  );
});

export default FileUpload;
